<template>
  <div>
    <b-modal
      :id="editModal.id"
      title="Edit Time Entry"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <EditTimer :previewItem="editModal.item" :modalId="editModal.id" />
    </b-modal>
  </div>
</template>

<script>
import EditTimer from "@/components/Timer/EditTimer";
export default {
  name: "EditTimerModal",
  props: ["editModal"],
  components: {
    EditTimer,
  },
};
</script>

<style scoped></style>
